import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="bg-white rounded-2xl shadow-sm border border-[#E8E6E1] overflow-hidden transition-all duration-300 hover:shadow-md" data-id="element-1">
      <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={onClick} aria-expanded={isOpen} data-id="element-2">
        <span className="font-serif text-lg text-gray-800 font-medium pr-4" data-id="element-3">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-[#5F8F6F] flex-shrink-0" data-id="element-4" /> : <ChevronDown className="w-5 h-5 text-[#9FB8C7] flex-shrink-0" data-id="element-5" />}
      </button>
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-6">
        <div className="px-6 pb-6 text-gray-600 leading-relaxed" data-id="element-7">{answer}</div>
      </div>
    </div>;
}
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Funciona si mi hijo todavía no reconoce letras?',
    answer: 'Sí. El programa comienza activando sonidos antes que letras. Está diseñado para niños que todavía no iniciaron formalmente la lectura.'
  }, {
    question: '¿Y si se frustra fácilmente?',
    answer: 'Justamente trabajamos desde el juego y micro avances diarios. La idea es construir confianza, no presión.'
  }, {
    question: '¿Tengo que ser docente para aplicarlo?',
    answer: 'No. Está pensado para padres. Cada actividad viene explicada paso a paso.'
  }, {
    question: '¿Cuánto tiempo real necesito dedicar?',
    answer: 'Solo 10 minutos por día. Es un sistema diseñado para encajar en rutinas reales.'
  }, {
    question: '¿En cuánto tiempo se ven cambios?',
    answer: 'La mayoría de las familias reportan mejoras en confianza y reconocimiento de sonidos en pocas semanas.'
  }, {
    question: '¿Qué pasa si no me resulta útil?',
    answer: 'Tenés 7 días de garantía total. Si no estás conforme, te devolvemos el dinero sin preguntas.'
  }];
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="space-y-4 max-w-3xl mx-auto" data-id="element-8">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => handleToggle(index)} data-id="element-9" />)}
    </div>;
}